export const getFormulaImageUrl = (src: string) => {
  return `https://cdn-st.stage.azure.viome.com/viome-cdn/media/app/products/${src}`;
};

export const getAddOnFormulaImageUrl = (src: string) => {
  return `https://cdn-st.stage.azure.viome.com/viome-cdn/media/app/v2/png/addon/${src}`;
};
